import { useEffect, useState } from "react";

import './App.css';

import 'bootstrap/dist/css/bootstrap.css';

import Deploy from './components/Deploy';
import Environment from "./components/Environment";
import Faucet from './components/Faucet';
import Interact from './components/Interact';
import Onboard from './components/Onboard';

import Accordion from 'react-bootstrap/Accordion';
import Stack from 'react-bootstrap/Stack';

import { PluginClient } from '@remixproject/plugin';
import { Theme } from '@remixproject/plugin-api';
import { createClient } from '@remixproject/plugin-webview';

function App() {
  const pluginClient = new PluginClient()
  const client = createClient(pluginClient)

  const [darkMode, setDarkMode] = useState(true)

  const handleThemeChanged = (_theme: Theme) => {
    if ('name' in _theme && _theme.name === 'Light') {
      setDarkMode(false)
    } else if ('name' in _theme && _theme.name === 'Dark') {
      setDarkMode(true)
    }
  }

  useEffect(() => {
    client.onload(async () => {
      const currentTheme = await client.theme.currentTheme()

      handleThemeChanged(currentTheme)

      client.on('theme', 'themeChanged', (_theme: Theme) => {
        handleThemeChanged(_theme)
      })
    })
  }, [])

  return (
    <>
      <Stack className={`plugin-container ${darkMode ? "dark" : ""}`} data-bs-theme={darkMode ? 'dark' : 'light'}>
        <p className="plugin-version"><b>v1.1.2</b></p>

        <Accordion defaultActiveKey="0">
          <div>
            <Faucet />
            <Onboard client={client} />
            <Deploy client={client} />
            <Interact client={client} />
          </div>
          <Environment client={client} />
        </Accordion>
      </Stack>
    </>
  );
}

export default App;
